"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRadius = exports.getLatLng = exports.getClosestLocation = exports.formatToDecimalPlaces = void 0;
/* eslint-disable regexp/no-unused-capturing-group, regexp/no-useless-quantifier */
const types_1 = require("../types");
const getRadius = (currSort, distance) => {
    if (distance) {
        return distance * 1000;
    }
    if (currSort?.field !== types_1.SortingField.Distance) {
        return undefined;
    }
    return 'all';
};
exports.getRadius = getRadius;
const getLatLng = (location) => {
    if (!location || !Object.keys(location).length) {
        return undefined;
    }
    const validLatLngRegexp = /^((-?|\+?)?\d+(\.\d+)?),\s*((-?|\+?)?\d+(\.\d+)?)$/;
    const latLng = `${location.lat}, ${location.long}`;
    if (!validLatLngRegexp.test(latLng)) {
        return undefined;
    }
    return latLng;
};
exports.getLatLng = getLatLng;
const formatToDecimalPlaces = (number, decimals) => {
    const [wholeNumber, decimalPlaces = ''] = number.toString().split('.');
    return [wholeNumber, decimalPlaces.slice(0, Math.max(0, decimals)).padEnd(decimals, '0')].join('.');
};
exports.formatToDecimalPlaces = formatToDecimalPlaces;
const getClosestLocation = (product) => {
    // eslint-disable-next-line no-underscore-dangle
    const matchedGeolocation = product._rankingInfo?.matchedGeoLocation;
    if (!matchedGeolocation) {
        return undefined;
    }
    const matchedLocation = product.locations?.find(location => formatToDecimalPlaces(location.position.lat, 4) ===
        formatToDecimalPlaces(matchedGeolocation.lat, 4) &&
        formatToDecimalPlaces(location.position.lon, 4) ===
            formatToDecimalPlaces(matchedGeolocation.lng, 4));
    return matchedLocation
        ? {
            distance: {
                unit: 'km',
                value: Math.ceil(matchedGeolocation.distance / 1000),
            },
            lat: matchedLocation.position.lat,
            long: matchedLocation.position.lon,
            name: matchedLocation.city,
        }
        : undefined;
};
exports.getClosestLocation = getClosestLocation;
//# sourceMappingURL=location.js.map